<template>
  <v-card>
    <v-card-title>
      Email Reminder
      <v-spacer/>
      <v-icon medium color="red" @click="cancelEmail"> mdi-close-circle-outline </v-icon>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md pa-0>
        <v-layout row wrap>
          <v-flex xs12>
            <v-autocomplete
              v-model="emailRecipients"
              :items="emailUsers"
              chips
              box
              label="To"
              item-text="text"
              item-value="value.EmailAddress"
              multiple
            >
            <template v-slot:selection="data">
              <v-chip
                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeEmail(data.item.value.EmailAddress)"
              >
              {{data.item.text}}

              </v-chip>
            </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs6 >
            <span class="addAll" @click="selectAllUsers">
              <b> Select all </b>
              <v-icon small>
                mdi-account-multiple-plus
              </v-icon>
            </span>
            
          </v-flex>
          <v-flex xs12>
            <v-text-field
              label="Subject"
              v-model="emailSubject"
            >
            </v-text-field>

          </v-flex>
          <v-flex xs12>
            <v-textarea
              label="Message"
              outline
              v-model="emailBody"
            >
            </v-textarea>
          </v-flex>
          
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="pipefishOrange" @click="cancelEmail">Cancel</v-btn>
      <v-btn color="pipefishGreen" @click="sendEmail">Send</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  mapState, mapMutations
} from 'vuex'
export default {
  props: ['userToEmail'],
  data:() => ({
    emailSubject: '',
    emailBody: '',
    emailRecipients: [],
  }),
  computed: {
    ...mapState('admin', ['pipefishUsers']),
    emailUsers: function() {
      return this.pipefishUsers.map(user => ({
        text: `${user.GivenName} ${user.Surname}`,
        value: user
      }))
    }
  },
  watch: {
    userToEmail: function(newEmail, oldEmail) {
      this.emailRecipients.push(newEmail)
    }
  },
  methods: {
    removeEmail(email) {
      var index = this.emailRecipients.indexOf(email)
      if(index > -1) {
        this.emailRecipients.splice(index, 1)
      }
    },
    selectAllUsers() {
      this.emailRecipients = this.pipefishUsers.map(user => user.EmailAddress)
    },
    cancelEmail() {
      this.resetEmailDialog()
    },
    sendEmail() {
      var self = this
      var toSend = this.emailRecipients.map(email => ({
        emailAddress: {
          address: email
        }
      }))
      this.$authService.getMSGraphToken().then(token => {
        self.$msGraphApi.sendEmail({
          subject: this.emailSubject,
          body: this.emailBody,
          recipients: toSend
        }, token).then(response => {
          self.resetEmailDialog()
        })
      })
    },
    resetEmailDialog() {
      this.emailDialog = false
      this.emailSubject = ''
      this.emailBody = ''
      this.emailRecipients = []
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
.addAll{
  border: 1px solid grey;
  border-radius: 10px;
  padding: 5px
}

.addAll:hover {
  background-color: #f5f5f5;
  cursor: pointer;
  opacity: 0.8;
}

</style>
